import React from 'react';
import { connectI18n } from '../../connects';
import APIConnectionWarning from '../../elements/APIConnectionWarning/APIConnectionWarning';
import Blocklink from '../../elements/Blocklink';
import Buttonlink from '../../elements/ButtonLink';
import HomeLogo from '../../elements/HomeLogo';
import Scrollable from '../../elements/Scrollable';
import TopBar from '../../elements/TopBar/TopBar';
import Screen from '../Screen';
import EmailLoginButton from './EmailLoginButton';
import LinkedinLogin from './LinkedinLoginButton';
import styles from './authentication.module.scss';
import AppleLoginButton from './AppleLoginButton';

class Welcome extends React.Component {
    render() {
        var i18n = this.props.i18n,
            header = (
                <>
                    <TopBar></TopBar>
                    <hr />
                    <HomeLogo></HomeLogo>
                    <hr />
                </>
            ),
            footer = <APIConnectionWarning />;

        return (
            <Screen header={header} footer={footer} className="authentication-screen">
                <Scrollable>
                    <div
                        style={{
                            padding: '40px 0 40px 30px',
                        }}>
                        <h3 style={{ marginBottom: '10px' }}>{i18n['label.statupscreen.registerlabel']}</h3>

                        <LinkedinLogin className={['margins', styles.ActionButton].join(' ')}>{i18n['label.register.by.linkedin']}</LinkedinLogin>
                        <AppleLoginButton className={['margins', styles.ActionButton].join(' ')} />
                        <EmailLoginButton className={['margins', styles.ActionButton].join(' ')} href="/register" next>
                            {i18n['label.register.by.email']}
                        </EmailLoginButton>
                        <div
                            style={{
                                padding: '37px 30px 0 0',
                            }}>
                            <Buttonlink href="/login" style={{ backgroundColor: 'white' }}>
                                {i18n['label.statupscreen.loginlabel']}
                            </Buttonlink>
                        </div>
                    </div>
                    <Blocklink className="margins" color="cyan" href="/get_most" next>
                        {i18n['label.about.netwerkapp']}
                    </Blocklink>
                </Scrollable>
            </Screen>
        );
    }
}

export default connectI18n(Welcome);
